module.exports = __webpack_public_path__ + "img/cust_tooltips_bibus.e93af783.webp";